import React from "react";

// Libraries
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Parallax } from "react-scroll-parallax";
import { m } from "framer-motion";

// Component
import Header, { HeaderNav, Menu } from "../../Components/Header/Header";
import Buttons from '../../Components/Button/Buttons'
import IconWithText from '../../Components/IconWithText/IconWithText'
import InteractiveBanners03 from "../../Components/InteractiveBanners/InteractiveBanners03";
import Clients from '../../Components/Clients/Clients'
import Lists from "../../Components/Lists/Lists";
import ProgressBar from "../../Components/Progressbar/ProgressBar";
import { TextAnime } from '../../Components/FancyText/FancyText'
import FooterStyle02 from "../../Components/Footers/FooterStyle02";
import { fadeIn, fadeInLeft } from "../../Functions/GlobalAnimations";
import SideButtons from "../../Components/SideButtons";
import InViewPort from "../../Components/InViewPort";

// Data
import { ProgressBarData02 } from "../../Components/Progressbar/ProgressBarData";
import { ListData01 } from "../../Components/Lists/ListsData";
import {
  AHS_CLIENT_LOGOS,
  homeFeaturedServices,
  homeServicesCarousel,
  whyChooseUsData,
} from "../../Data/AHSContent";

const homeWhyChooseUsIcons = whyChooseUsData.map(({ icon, title, content }) => ({
  icon,
  title,
  content,
}));

const CorporatePage = (props) => {
  const swiperRef = React.useRef(null);
  return (
    <div style={props.style}>
      <SideButtons />
      {/* Header Start*/}
      <Header topSpace={{ md: true }} type="reverse-scroll">
        <HeaderNav fluid="fluid" theme="dark" expand="lg" className="py-[0px] px-[35px] md:px-[15px] md:py-[20px] sm:px-0">
          <Col lg={2} sm={6} xs={"auto"} className="mr-auto ps-0">
            <Link aria-label="header logo" className="flex items-center" to="/">
              <Navbar.Brand className="inline-block p-0 m-0">
                <img className="default-logo" width="111" height="36" loading="lazy" src='/assets/img/Globe.gif' data-rjs='/assets/img/Globe.gif' alt='logo' />
                <img className="alt-logo" width="111" height="36" loading="lazy" src='/assets/img/Globe.gif' data-rjs='/assets/img/Globe.gif' alt='logo' />
                <img className="mobile-logo" width="111" height="36" loading="lazy" src='/assets/img/Globe.gif' data-rjs='/assets/img/Globe.gif' alt='logo' />
              </Navbar.Brand>
            </Link>
          </Col>
          <Navbar.Toggle className="order-last md:ml-[17px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="justify-center col-auto col-lg-10">
            <Menu {...props} />
          </Navbar.Collapse>
        </HeaderNav>
      </Header>
      {/* Header Start*/}
      {/* Section Start */}
      <m.section className="relative full-screen overflow-hidden landscape:md:h-[500px]" {...fadeIn}>
        <Parallax className="lg-no-parallax bg-cover cover-background absolute bg-top left-0 md:-top-[30px] w-full h-[100vh]" translateY={[-40, 40]} style={{ backgroundImage: `url(/assets/img/jpg/IMG_0092New.jpg)` }}></Parallax>
        <div className="absolute h-full w-full opacity-30 top-0 left-0 bg-gradient-to-r from-[#040506] to-[#130e3e] rotate-[30px]"></div>
        <Container className="h-full text-center justify-center">
          <Row className="h-full justify-center">
            <Col
              xl={6}
              lg={7}
              md={10}
              className="justify-center flex-col relative flex text-center"
            >
              <span className="mb-[20px] font-medium text-[#2ed47c] text-md md:text-xmd font-serif block xs:mb-[10px] uppercase tracking-[1px]">
                The best security service
              </span>
              <h2 className="font-semibold text-[#fff] text-shadow-large font-serif landscape:md:mb-[30px] mb-[35px]">
                Highly trained persons
              </h2>
              <p className="text-[#fff] opacity-80 mb-[35px] max-w-[520px] mx-auto font-sans">
                Our security management services ensure that your security needs are duly and timely met.
              </p>
              <div className="flex flex-wrap justify-center gap-[15px]">
                <Buttons
                  to="/page/about-us"
                  className="font-medium font-serif uppercase rounded-none"
                  themeColor="#0038e3"
                  color="#fff"
                  size="lg"
                  title="About us"
                />
                <Buttons
                  to="/page/our-services"
                  className="font-medium font-serif uppercase rounded-none"
                  themeColor="#2ed47c"
                  color="#232323"
                  size="lg"
                  title="Services"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Section End */}
      {/* Section Start */}
      <m.section
        className="py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]"
        {...fadeIn}
      >
        <Container>
          <Row className="items-center justify-center md:items-start sm:text-center">
            <Col lg={4} md={6} className="md:mb-[50px]">
              <m.div className="inline-block text-center w-[300px] py-14 px-[15px] relative" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                <div className="border-r-0 border-solid	border-[10px] border-[#2ed47c] h-full w-[67px] block absolute bottom-0 left-0"></div>
                <h1 className="text-[80px] leading-[72px] mb-0 mr-[15px] font-semibold tracking-[-5px] text-darkgray font-serif inline-block align-middle">
                  28+
                </h1>
                <div className="w-[40%] leading-[20px] font-medium text-darkgray text-xmd font-serif text-left relative inline-block align-middle lg:w-[50%] sm:w-[35%]">
                  Years of trusted service
                </div>
                <div className="border-l-0 border-solid	border-[10px] border-[#2ed47c] h-full w-[67px] block absolute bottom-0 right-0"></div>
              </m.div>
            </Col>
            <Col lg={3} md={4}>
              <m.div {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                <span className="mb-[20px] text-md font-serif uppercase block">
                  AN Hour Solution Pvt. Ltd.
                </span>
                <span className="w-[85%] leading-[34px] font-medium text-darkgray text-xlg font-serif block lg:leading-0 lg:text-lg sm:w-full sm:mb-[15px]">
                  Your one stop destination for facility management in Kolkata
                </span>
              </m.div>
            </Col>
            <Col lg={5} md={10}>
              <m.div {...{ ...fadeIn, transition: { delay: 0.6 } }}>
                <p className="w-[84%] mb-[25px] block lg:w-full">
                  Have all hassle free services at one point — plumbing, carpentry, electrical, AC,
                  housekeeping, security and more. Just call us and we will reach you as per your
                  expected timings.
                </p>
                <Buttons
                  to="/page/about-us"
                  className="font-medium font-serif uppercase btn-link text-md after:bg-black after:h-[1px] after:!-bottom-[5px] hover:text-darkgray md:text-md md:mb-[15px]"
                  color="#232323"
                  title="About us"
                  size="xl"
                />
              </m.div>
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Section End */}
      
      <InViewPort>
        {/* Section Start */}
        <section className="bg-lightgray py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
          <Container>
            <Row className="justify-center">
              <Col lg={6} md={7} sm={8} className="text-center mb-24">
                <m.h2 className="heading-4 font-semibold -tracking-[1px] text-darkgray font-serif" {...fadeIn} >
                  Why choose us?
                </m.h2>
                <m.p className="mt-[15px] mb-0" {...fadeIn}>
                  Every case is very important to us and we always take care of them seriously.
                </m.p>
              </Col>
            </Row>
            <IconWithText
              grid="row-cols-1 row-cols-lg-4 row-cols-sm-2 justify-center"
              theme="icon-with-text-07"
              data={whyChooseUsData}
              animation={fadeIn}
            />
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <m.section
          className="cover-background py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]"
          style={{
            backgroundImage:
              "url(/assets/img/webp/home-corporate-hand-crafted-bg.webp)",
          }}
          {...fadeIn}
        >
          <Container>
            <Row className="items-center justify-center">
              <Col xs={10} lg={6} className="relative">
                <div className="relative">
                  <Parallax className="lg-no-parallax w-[70%]" speed={0}>
                    <img width="" height="" alt="Flooring sample" src="/assets/img/jpg/Flooring3_420.jpg" />
                  </Parallax>
                  <Parallax className="lg-no-parallax flex justify-center items-center w-1/2 bg-no-repeat absolute bottom-0 right-[15px] lg:!left-auto lg:!top-[150px] sm:!top-[100px]" speed={20}>
                    <img width="341.25px" height="349.78px" alt="Glass film sample" src="/assets/img/jpg/GlassFilm1_420.jpg" />
                  </Parallax>
                </div>
              </Col>
              <Col xs={10} xl={{ span: 4 }} lg={{ span: 5, offset: 1 }} className="md:mt-[15%] xs:mt-[18%]">
                <m.h2 className="heading-4 mb-16 font-semibold -tracking-[1px] text-darkgray font-serif" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                  Specialised & customised facility management solutions
                </m.h2>
                <m.span className="mb-[5px] font-serif text-darkgray font-medium block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                  Your one stop destination
                </m.span>
                <m.p className="mb-0 w-[85%]" {...{ ...fadeIn, transition: { delay: 0.5 } }}>
                  Have all hassle-free services at one point. No need to call separately for plumbing, carpentry, electrical, AC, housekeeping, etc
                </m.p>
                <m.span className="h-[1px] my-12 bg-mediumgray w-full block sm:my-6" {...{ ...fadeIn, transition: { delay: 0.6 } }}></m.span>
                <m.span className="mb-[5px] font-serif text-darkgray font-medium block" {...{ ...fadeIn, transition: { delay: 0.7 } }}>
                  Strategy-focused organisation
                </m.span>
                <m.p className="mb-0 w-[85%]" {...{ ...fadeIn, transition: { delay: 0.8 } }}>
                  We are a strategy-focused organisation driven by performance benchmarks and efficient management processes at corporate and operational levels.
                </m.p>
                <m.div {...{ ...fadeIn, transition: { delay: 1 } }}>
                  <Buttons
                    className="font-medium font-serif uppercase hover:text-darkgray btn-expand mt-[56px]"
                    size="lg"
                    color="#232323"
                    themeColor="#2ed47c"
                    to="/"
                    title="Explore Features"
                  />
                </m.div>
              </Col>
            </Row>
          </Container>
        </m.section>
        {/* Section End */}

        {/* Section Start */}
        <section className="bg-lightgray py-[130px] lg:py-[90px] md:py-[75px] sm:[50px]">
          <Container>
            <m.div className="row justify-center">
              <m.div className="col col-lg-6 cpl-md-8 col-sm-10 mb-24 text-center" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                <h2 className="heading-4 font-semibold -tracking-[1px] text-darkgray font-serif">
                  Our services
                </h2>
                <p className="w-[80%] my-0 mx-auto xs:w-full">
                  Security, facility management, housekeeping, telecom, electrical maintenance and more.
                </p>
              </m.div>
            </m.div>
            <InteractiveBanners03
              grid="row-cols-1 row-cols-lg-2 gap-y-[15px]"
              overlay={["#2ed47ce6", "#0038e3e6"]}
              data={homeFeaturedServices}
              animation={fadeIn}
            />
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]">
          <Container>
            <Row className="mb-36 md:mb-20 xs:mb-12">
              <m.div className="col col-xl-4 col-lg-5 col-md-6 xs:mb-8" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                <h2 className="heading-4 mb-[30px] font-semibold -tracking-[1px] text-darkgray font-serif">
                  Certified & experienced teams
                </h2>
                <p className="w-[85%] xs:mb-[15px] landscape:md:mb-[15px]">
                  Government certified experts delivering security, facility management and
                  maintenance services across Eastern India.
                </p>
              </m.div>
              <Col lg={{ span: 6, offset: 1 }} xl={{ span: 6, offset: 2 }} md={6} className="xs:mb-[30px]">
                <ProgressBar
                  trailColor="transparent"
                  theme="progressbar-style-02"
                  height="8px"
                  data={ProgressBarData02}
                  color={["#2ed47c", "#e8bf47"]}
                  animation={fadeIn}
                />
              </Col>
            </Row>
            <IconWithText
              grid="row-cols-1 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 gap-y-[30px] justify-center"
              theme="icon-with-text-01"
              data={homeWhyChooseUsIcons.slice(0, 3)}
              animation={fadeIn}
              animationDelay={0.2}
            />
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <m.section
          className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] bg-lightgray overflow-hidden"
          {...fadeIn}
        >
          <Container>
            <Row className="items-center justify-center">
              <Col lg={6} md={9} className="p-0 md:mb-[30px]">
                <m.div className="relative" {...fadeIn}>
                  <div
                    onClick={() => swiperRef.current.swiper.slidePrev()}
                    className="btn-slider-prev bg-darkgray z-[11] text-[#fff] w-[50px] h-[50px] left-[15px] transition-default leading-[40px] m-0 right-auto absolute top-[47%] flex item-center justify-center hover:bg-white hover:text-darkgray  cursor-pointer"
                  >
                    <button className="text-xmd" aria-label="prev btn">
                      <i className="feather-arrow-left"></i>
                    </button>
                  </div>

                  <div
                    onClick={() => swiperRef.current.swiper.slideNext()}
                    className="btn-slider-next btn-slider-next bg-darkgray z-[11] text-[#fff] w-[50px] transition-default h-[50px] right-[15px] leading-[40px] m-0 left-auto absolute top-[47%] flex item-center justify-center hover:bg-white hover:text-darkgray  cursor-pointer"
                  >
                    <button className="text-xmd" aria-label="next btn">
                      <i className="feather-arrow-right"></i>
                    </button>
                  </div>
                  <Swiper
                    className="black-move swiper-pagination-medium h-full"
                    ref={swiperRef}
                    modules={[Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                  >
                    {homeServicesCarousel.map((item, i) => {
                      return (
                        <SwiperSlide key={i} className="p-[15px]">
                          <div className="h-full bg-[#fff] box-shadow">
                            <img className="w-full h-[320px] object-cover" src={item.img} alt="TestimonialsCarousel" width={555} height={432} />
                            <div className="items-center justify-center text-center flex px-[4.5rem] py-14 flex-row	xs:p-8">
                              <div className="grow-0 shrink-0 basis-auto flex-initial pr-[40px] xs:pr-[15px]">
                                <h2 className="heading-4 font-semibold text-darkgray font-serif mb-0">
                                  {item.number}
                                </h2>
                              </div>
                              <div className="overflow-hidden max-w-full pl-[40px] border-basecolor border-l-[2px] text-left xs:pl-[15px]">
                                <span className="mb-[5px] font-medium text-darkgray text-xmd font-serif block">
                                  {item.title}
                                </span>
                                <p className="mb-0">{item.content}</p>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </m.div>
              </Col>
              <m.div
                className="col-lg-5 col-md-9 offset-lg-1"
                {...fadeInLeft}
              >
                <h2 className="heading-4 mb-[40px] leading-[40px] font-semibold tracking-[-1px] text-darkgray font-serif xs:mb-[20px]">
                  <span className="p-0 block">Trusted by leading</span>
                  <TextAnime
                    duration={3000}
                    color="#232323"
                    className="font-semibold animated-text-black"
                    animation="slide"
                    data={["corporate brands", "banks & retail", "industrial clients"]}
                  />
                </h2>
                <p className="w-[90%] mb-[30px] xs:w-full">
                  We partner with organizations across banking, telecom, steel, hospitality and
                  more to deliver reliable facility and security solutions.
                </p>
                <m.div className="col w-[85%] xs:w-full">
                  <Lists
                    className="font-medium"
                    theme="list-style-01"
                    data={ListData01}
                  />
                </m.div>
              </m.div>
            </Row>
          </Container>
        </m.section>
        {/* Section End */}

        {/* Team section removed */}

        {/* Interesting articles section removed */}

        {/* Section Start */}
        <section className="py-[100px] md:py-[75px] sm:py-[50px]">
          <div className="w-full px-0">
            <Clients
              theme="client-logo-style-06 light"
              data={AHS_CLIENT_LOGOS}
              animation={fadeIn}
              carousel={true}
              carouselOption={{
                slidesPerView: 5,
                spaceBetween: 30,
                speed: 4500,
                autoplay: {
                  delay: 1,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                },
                allowTouchMove: false,
                loop: true,
                breakpoints: {
                  320: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 3, spaceBetween: 24 },
                  992: { slidesPerView: 4, spaceBetween: 28 },
                  1200: { slidesPerView: 5, spaceBetween: 30 },
                },
              }}
            />
          </div>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <m.section className="relative" {...fadeIn}>
          <div style={{ backgroundImage: "url('/assets/img/webp/transparent.webp')" }} className="mxl:bg-cover py-[100px] lg:py-[90px] md:py-[75px] sm:py-[50px] sm:px-[15px] bg-fixed lg:bg-cover lg:bg-local lg:bg-center" >
            <div className="left-0 top-0 h-full w-full absolute bg-darkslateblue opacity-75"></div>
            <Container className="relative">
              <Row className="justify-center items-center">
                <Col xl={7} md={8} sm={10} className="md:mb-[30px] sm:mb-[30px]">
                  <h2 className="heading-4 font-serif font-semibold text-white mb-[15px] sm:text-center">
                    Are you looking for a long term facility management partner?
                  </h2>
                  <p className="text-white opacity-80 mb-0 sm:text-center">
                    We offer personalized services combined with customized tailor made solutions that best suit your needs.
                  </p>
                </Col>
                <Col xl={5} md={4} className="md:flex md:justify-center text-end">
                  <Buttons
                    to="/page/contact-modern"
                    className="font-medium font-serif uppercase rounded-none"
                    themeColor="#2ed47c"
                    size="lg"
                    color="#232323"
                    title="Contact now"
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </m.section>
        {/* Section End */}

        {/* Footer Start */}
        <FooterStyle02 theme="dark" className="bg-[#262b35] text-slateblue" />
        {/* Footer Start */}
      </InViewPort>
    </div>
  );
};

export default CorporatePage;
